import React, { Fragment } from 'react';
import Api from '../../api/api';
import QRCode from "react-qr-code";
import OverlayLoading from '../common/overlay-loading';
import authy from '../../assets/images/authy-ar21.svg';

export default class Security extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            validTwoFA: false,
            form: {
                code: '',
                token: '',
            }
        }
    }

    componentDidMount = () => {
        this.updateInfo();
    }

    updateInfo = async () => {
        this.setState({ loading: true });

        let req = await Api.get('auth/me');
        if (req.error) return;
        const validTwoFA = req.data.user.validTwoFA;

        if (!validTwoFA) {
            let req = await Api.get('auth/2fa/secret');
            if (req.error) return;
            const token = req.data.token;

            this.setState({
                loading: false,
                validTwoFA: validTwoFA,
                form: {
                    token: token,
                    code: '',
                }
            })
        } else {
            this.setState({
                loading: false,
                validTwoFA: validTwoFA,
                form: {
                    token: '',
                    code: '',
                }
            })
        }
    }

    handleChange = (event) => {
        let form = this.state.form
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
        form[event.target.name] = value
        this.setState({ form })
    }

    activate = async (event) => {
        event.preventDefault();

        await this.setState({ loading: true });
        let form = this.state.form;
        await Api.post(`auth/2fa/active`, {
            token: form.code
        });
        this.updateInfo();
    }

    disable = async (event) => {
        event.preventDefault();

        await this.setState({ loading: true });
        let form = this.state.form;
        await Api.post(`auth/2fa/deactivate`, {
            token: form.code
        });
        this.updateInfo();
    }

    render() {
        return (
            <Fragment>
                <OverlayLoading show={this.state.loading} />
                <div className="container-fluid pt-5">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Security</h5>
                                </div>
                                <div className="card-body">
                                    <div className="media-body">

                                        {(this.state.validTwoFA) && <>
                                            <h5 className='txt-success'><i className="fas fa-check-circle"></i>2FA Activated</h5>
                                            <p className="mt-4">To <span className="bold">disable</span> two-factor authentication</p>
                                            <p>Enter the 6-digit token that was generated and click deactivate</p>
                                        </>}
                                        {(!this.state.validTwoFA) && <>
                                            <h5>1 - Install the APP</h5>
                                            <p>Download the app from the Apple Store or Google Play</p>
                                            <img className="blur-up lazyloaded" src={authy} style={{
                                                width: 100,
                                                marginBottom: 38,
                                                marginTop: 20,
                                            }} alt="authy" />
                                            <h5>2 - Read the QR Code</h5>
                                            <p>Open the app and scan the QR Code below</p>
                                            <QRCode value={this.state.form.token} size={120} />
                                            <h5 className="mt-3">3 - Inform the token</h5>
                                            <p>Enter the 6-digit token that was generated and click activate</p>
                                        </>}

                                        <div className="row">
                                            <div className="col">
                                                <div className="form-group">
                                                    <label>Code</label>
                                                    <input className="form-control"
                                                        type="number"
                                                        name="code"
                                                        value={this.state.form.code}
                                                        onChange={this.handleChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col">
                                                {(!this.state.validTwoFA) && <>
                                                    <button className="btn btn-primary" onClick={this.activate}>2FA Activate</button>
                                                </>}
                                                {(this.state.validTwoFA) && <>
                                                    <button className="btn btn-danger" onClick={this.disable}>2FA Disable</button>
                                                </>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}